import { forwardRef, createElement } from 'react';

function IconLog(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V10.5h-1.5V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V19H20v1.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zm-.105 10.074c1.447 0 2.3.875 2.367 2.279l.004.178v.621c0 1.5-.863 2.446-2.371 2.446-1.444 0-2.304-.872-2.371-2.268l-.004-.178v-.62c0-1.516.871-2.458 2.375-2.458zm5.362 0c1.328 0 2.058.776 2.172 1.653l.012.132h-1.25c-.074-.414-.406-.734-.945-.734-.638 0-1.007.443-1.05 1.222l-.005.16v.626c0 .805.293 1.414 1.09 1.414.598 0 .914-.34.956-.745l.005-.095v-.234h-.93v-.903h2.14v1.04c0 1.038-.667 1.988-2.199 1.988-1.57 0-2.3-.987-2.355-2.296l-.004-.165v-.64c0-1.427.84-2.423 2.363-2.423zm-10.182.094v4.262h2.141v1.07H7.376v-5.332h1.285zm4.82.95c-.597 0-1.012.415-1.062 1.23l-.005.168v.64c0 .926.43 1.399 1.067 1.399.593 0 1.008-.416 1.057-1.23l.005-.169v-.64c0-.926-.43-1.399-1.062-1.399zM14.5 4.62v2.63a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Log = /*#__PURE__*/forwardRef(IconLog);

export default Log;
//# sourceMappingURL=Log.js.map
